<div>
    <div class="plan-options-individual" style="border:0px solid black;" *ngIf="data">
        <img class="plan-options-image" src="assets/images/vw-logo.png" width="100px;" alt="logo" />
        <app-vwsa-text text="R{{data.price | number}} (incl. VAT)" weight="bold">
        </app-vwsa-text>
        <app-vwsa-text text="{{data.planType}} - {{data.years}} Years - {{data.maxKilometers}} KM"></app-vwsa-text>
        <div style="margin-top:10px;">
            <app-vwsa-button text="{{buttonText}}" (click)="viewQuote()"></app-vwsa-button>
        </div>
    </div>
</div>